// THE FAR RING'S QUICK PAINT IN THE CLIENT WORKER POOL (far-field-load;
// client/src/pool.js, an op of poolwork.js OPS).
//
//   ring.quick {world, sector, level, heights}
//                 ringref.js ringPaint(world, sector, level, heights,
//                 {noTex, noVis}) of one far sector: the genome record's
//                 class mean (elevation / slope terms) or the palette colour,
//                 x the S2 residual x the anchor, under the sun on the
//                 heights' normals (no sky visibility, no texel detail) —
//                 the sector's FIRST colour, from the world's data alone
//                 (ringgen.js quick). world: ringref ringWorld (structured
//                 clone: its gP / gLab caches stay here); sector: { id, tier,
//                 rect, px, cls, res } (ringgen exactSector: sha-checked);
//                 heights: ringref quickHeights at that level (Float32Array,
//                 transferred). ~56 ms a sector on a desktop core.
//                 -> { rgba (Uint8Array w x h x 4, row 0 = south, the atlas's
//                 upload; transferred), rgb [r, g, b] (sRGB8: the mean in
//                 linear, the flat colour faratlas.js keeps when it evicts
//                 the entry) }
//
// Pure + DOM-free (the worker bundle: poolwork.js imports this module).
import { ringPaint } from './ringref.js';

const dec = (c) => (c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
const enc = (c) => (c <= 0.0031308 ? c * 12.92 : 1.055 * c ** (1 / 2.4) - 0.055);

function ringQuick({ world, sector, level, heights }) {
  const { rgba } = ringPaint(world, sector, level, heights, { noTex: true, noVis: true });
  const L = new Float64Array(256), m = [0, 0, 0], n = rgba.length >> 2;
  for (let v = 0; v < 256; v++) L[v] = dec(v / 255);
  for (let k = 0; k < n; k++) for (let c = 0; c < 3; c++) m[c] += L[rgba[4 * k + c]];
  const rgb = m.map((v) => Math.round(255 * enc(v / Math.max(1, n))));
  return { result: { rgba, rgb }, transfer: [rgba.buffer] };
}

// poolwork.js OPS (spread in)
export const RING_OPS = {
  'ring.quick': ringQuick,
};
